module.exports = __webpack_public_path__ + "img/sample_template.73bce236.png";